import React from 'react';
import { useTranslation } from 'react-i18next';

/** The year is said here and changed at the foot: a second pager read as a different question. */
const BudgetYearHeader = ({
  title,
  figuresFailed,
  onRetryFigures,
  controls,
}: {
  title: string;
  /** The sprint list could not be read, so the figures under this header are not the year's. */
  figuresFailed?: boolean;
  /** Asks for the sprint list again. */
  onRetryFigures?: () => void;
  /** On the right, across from the title: which reading of the year is on screen. */
  controls?: React.ReactNode;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 className="text-lg font-bold text-foreground">{title}</h2>

      <div className="flex flex-wrap items-center justify-end gap-x-4 gap-y-2">
        {/* Beside the title, not in a toast: wrong figures must not show silently. */}
        {figuresFailed && onRetryFigures && (
          <span className="flex items-center gap-1.5 text-xs text-destructive">
            {t('budget.sheet.figuresFailed')}
            <button type="button" onClick={onRetryFigures} className="font-medium underline underline-offset-2">
              {t('budget.sheet.retry')}
            </button>
          </span>
        )}
        {controls}
      </div>
    </div>
  );
};

export default BudgetYearHeader;
